import React from "react";
import { Mui } from "../../libraries/material";

const Breakups = Mui.createSvgIcon(
  <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g
      id="Artboard"
      transform="translate(-644.000000, -42.000000)"
      fillRule="nonzero"
    >
      <g id="breakups" transform="translate(644.000000, 42.000000)">
        <path
          d="M12,22.3333364 C12.132165,22.3333364 12.2897317,22.2951208 12.4726984,22.2186891 C12.6556651,22.1422577 12.8132318,22.0581831 12.9453651,21.9664664 C15.2325321,20.5193595 17.2020324,18.9983693 18.853866,17.4035024 C20.5057328,15.8086022 21.7763664,14.167902 22.6658331,12.4813017 C23.5552666,10.7947015 24,9.09026793 24,7.36800102 C24,5.93110082 23.7026666,4.65723398 23.1080332,3.54643383 C22.5133331,2.43563367 21.7051997,1.56686688 20.6835995,0.940100131 C19.6620327,0.31336671 18.5158992,0 17.2452657,0 C16.0559322,0 15.0241654,0.300633375 14.1499653,0.901900125 C13.2757318,1.50316688 12.5590984,2.30313365 12,3.30186713 C11.4510983,2.31333365 10.7395315,1.51590021 9.86533137,0.90953346 C8.99109792,0.303166709 7.95426444,0 6.75476427,0 C5.48413076,0 4.3405306,0.31336671 3.32403046,0.940100131 C2.30749699,1.56686688 1.49936354,2.43563367 0.899596792,3.54643383 C0.299870042,4.65723398 5.92119029e-16,5.93110082 5.92119029e-16,7.36800102 C5.92119029e-16,9.09026793 0.444730062,10.7947015 1.33416352,12.4813017 C2.22363031,14.167902 3.49429715,15.8086022 5.14613071,17.4035024 C6.79796428,18.9983693 8.76746455,20.5193595 11.0546649,21.9664664 C11.1969649,22.0581831 11.3570649,22.1422577 11.5349316,22.2186891 C11.7128316,22.2951208 11.867865,22.3333364 12,22.3333364 Z"
          id="Path"
          fill="currentColor"
          opacity=".6"
        ></path>
        <path
          d="M15.8415989,0.156366688 L14.364632,2.68573371 L12.3660651,7.06863432 L16.3319656,10.5123681 L12.1786984,16.1162022 L13.7088652,10.8880348 L8.64999787,7.44433437 L10.1489314,3.03013375 L10.7690648,1.66123356 C11.2439316,2.1323003 11.6542316,2.67916704 11.9999983,3.30186713 C12.5590984,2.30313365 13.2757318,1.50316688 14.1499653,0.901900125 C14.6601654,0.551000077 15.2240321,0.302466709 15.8415989,0.156366688 Z"
          id="Path"
          opacity=".8"
          fill="currentColor"
        ></path>
      </g>
    </g>
  </g>,
  "breakups"
);

export default Breakups;
